import { render } from "./RequisiteDetail.vue?vue&type=template&id=5af592ab&scoped=true"
import script from "./RequisiteDetail.vue?vue&type=script&lang=js"
export * from "./RequisiteDetail.vue?vue&type=script&lang=js"

import "./RequisiteDetail.vue?vue&type=style&index=0&id=5af592ab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af592ab"]])

export default __exports__